export default __webpack_public_path__ + "static/media/frame.4e50e9119db83115f38d384a409d37e1.svg";